import { useContext, useMemo, useState } from "react";
import { ApiClient } from "../../../../utils/axiosConfig";
import { useGoogleAnalyticsEvent } from "../../../../hooks/useGoogleAnalitycs";
import {
  EventsAction,
  EventsCategories,
} from "../../../../utils/enums/googleAnalyticsEvents";
import { ABCoin } from "../AboutUs";
import { navigate } from "gatsby";
import { LangContext } from "../../../../context/lang/LangContext";
import environments from "../../../../utils/config/environments";

export const useAboutUs = () => {
  const [email, setEmail] = useState("");
  const { messages } = useContext(LangContext);

  const abCoin = useMemo(() => {
    if (typeof window === "undefined") return ABCoin.A;
    const coin = localStorage.getItem("ABCoin");
    return coin as ABCoin;
  }, []);

  const { post } = ApiClient();

  const [onClickSubmitEmail] = useGoogleAnalyticsEvent([
    {
      category: EventsCategories.AboutUs,
      label: "user submit email with form " + abCoin,
      value: 1,
      action: EventsAction.Submit,
      actionName: "form " + abCoin,
    },
  ]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    onClickSubmitEmail(e);
    e.preventDefault();
    try {
      const path = "/api/early-access/public/request";
      await post(path, { email });
      setEmail("");
    } catch (error) {
    } finally {
      navigate("/" + messages.currentLanguage + "/early-access/");
    }
  };

  const handleSubmitSuscribeForm = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    onClickSubmitEmail(e);
    e.preventDefault();
    try {
      const path = "/api/early-access/public/request";
      await post(path, { email });
      setEmail("");
    } catch (error) {
    } finally {
      switch (messages.currentLanguage) {
        case "es":
          window.open(environments.suscribeFormSpanish, "_blank");
          break;
        case "en":
          window.open(environments.suscribeFormEnglish, "_blank");
          break;
        default:
          window.open(environments.suscribeFormEnglish, "_blank");
          break;
      }
    }
  };

  const emailValidate = (email: string) =>
    /^[a-zA-Z0-9.!#$%&'*/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(
      email,
    );

  const isValidEmail = useMemo(() => {
    return emailValidate(email);
  }, [email]);

  return {
    handleInputChange,
    handleSubmit,
    email,
    isValidEmail,
    handleSubmitSuscribeForm,
  };
};
